import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { ColumnBar } from './ColumnBar';
import type { Column } from '../../lib/columns';

type Props = { columns: Column[] };

// Layout: bis zu 5 Säulen nebeneinander, gleiche Y-Skala. Auf schmalem
// Viewport stapeln sie sich (flex-wrap). Bar-Höhe ist auf 160 px fix —
// alle Säulen teilen sich ein gemeinsames Max.
export function ColumnsCard({ columns }: Props) {
  const scaleMax = Math.max(
    1,
    ...columns.map(c => Math.round(c.stories) + Math.round(c.bugs))
  );

  return (
    <Box sx={{ overflowX: 'auto' }}>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          minWidth: 600,
          py: 2,
          px: 1,
          alignItems: 'flex-start',
        }}
      >
        {columns.map(c => (
          <ColumnBar key={c.key} col={c} scaleMax={scaleMax} />
        ))}
      </Stack>
    </Box>
  );
}
